export default __webpack_public_path__ + "static/media/blue-loader.fd118a20.svg";